import { createOptionsSelector, sortByName } from '@mews-commander/utils';
import { getKeyCutters } from '@mews-commander/legacy-entities/src/reducers/keyCutters';

export const getKeyCutterOptions = createOptionsSelector(getKeyCutters, {
    value: 'id',
    label: 'name',
    sortFunction: sortByName,
});
